import React from 'react'
import PropTypes from 'prop-types'
import { Element as ScrollElement } from 'react-scroll'

import MenuItem from '../MenuItem'
import { CategoryContainer, CategoryTitle, MenuListContainer } from './styled'
import slugify from 'utils/slugify'

class MenuList extends React.Component {
  render() {
    const { name, items, orders, openModal } = this.props

    return (
      <CategoryContainer as={ScrollElement} name={slugify(name)}>
        <CategoryTitle>{name}</CategoryTitle>
        <MenuListContainer>
          {items.map(item => (
            <MenuItem
              key={item.id}
              menu={item}
              orders={orders}
              openModal={openModal}
            />
          ))}
        </MenuListContainer>
      </CategoryContainer>
    )
  }
}

MenuList.propTypes = {
  name: PropTypes.string,
  items: PropTypes.array,
  orders: PropTypes.array,
  openModal: PropTypes.func,
}

export default MenuList
